var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6812",
    "data-name": "Groupe 6812",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9652",
    "data-name": "Trac\\xE9 9652",
    d: "M1,5.5H6.5a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V4.5A1,1,0,0,0,1,5.5ZM1,1H6.5V4.5H1Z",
    fill: "#b5b5b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9653",
    "data-name": "Trac\\xE9 9653",
    d: "M365.166,0h-1.5a1,1,0,0,0-1,1V4.5a1,1,0,0,0,1,1h1.5a1,1,0,0,0,1-1V1A1,1,0,0,0,365.166,0Zm0,4.5h-1.5V1h1.5Z",
    transform: "translate(-354.165)",
    fill: "#b5b5b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9654",
    "data-name": "Trac\\xE9 9654",
    d: "M2.5,277.333H1a1,1,0,0,0-1,1v3.5a1,1,0,0,0,1,1H2.5a1,1,0,0,0,1-1v-3.5A1,1,0,0,0,2.5,277.333Zm0,4.5H1v-3.5H2.5Z",
    transform: "translate(0 -270.83)",
    fill: "#b5b5b5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9655",
    "data-name": "Trac\\xE9 9655",
    d: "M198.5,277.333H193a1,1,0,0,0-1,1v3.5a1,1,0,0,0,1,1h5.5a1,1,0,0,0,1-1v-3.5A1,1,0,0,0,198.5,277.333Zm0,4.5H193v-3.5h5.5Z",
    transform: "translate(-187.496 -270.83)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/Model.9b7733b83706faac133683af5fe1258d.svg";
export { ForwardRef as ReactComponent };